import React from "react";
import { Typography, Box, Stack } from "@mui/material";

export default function CardProduct(props) {
  return (
    <Stack direction="column" spacing={2}>
      <Box
        sx={{
          backgroundColor: "#fff",
          width: {
            lg: "150px",
            md: "125px",
            xs: "70px",
          },
          height: {
            lg: "150px",
            md: "125px",
            xs: "70px",
          },
          borderRadius: 5,
        }}
      >
        <Box
          component="img"
          sx={{
            backgroundColor: "#fff",
            width: {
              lg: "100%",
              md: "125px",
              xs: "100%",
            },
            height: {
              lg: "auto",
              md: "125px",
              xs: "auto",
            },
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: 5,
          }}
          src={props.data?.logo_full_path}
          alt={props.data?.name}
        />
      </Box>
      <Box sx={{ width: "100%", mt: "20px" }}>
        <Typography
          sx={{
            fontWeight: "bold",
            color: "#fff",
            fontSize: 14,
          }}
        >
          {props.data?.name}
        </Typography>
      </Box>
      <Box sx={{ width: "100%" }}>
        <Typography variant="body3" sx={{ fontSize: 12, color: "#fff" }}>
          {props.data?.company_name || "PT. Mcash Integrasi, Tbk"}
        </Typography>
      </Box>
    </Stack>
  );
}
